// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__1Kzpz","buttons":"PendingPaymentAlert_buttons__2kHEo"};